(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-review-grid-load-more]');
    if (!btn) return;
    var section = btn.closest('.review-grid-section');
    if (!section) return;
    var wrapper = section.querySelector('.review-grid-wrapper');
    if (!wrapper) return;
    wrapper.classList.toggle('review-grid--expanded');
    var expanded = wrapper.classList.contains('review-grid--expanded');
    btn.classList.toggle('is-expanded', expanded);
    var label = btn.querySelector('.review-grid-load-more__label');
    if (label) {
      var more = btn.getAttribute('data-load-more-label') || 'Toon meer';
      var less = btn.getAttribute('data-load-less-label') || 'Toon minder';
      label.textContent = expanded ? less : more;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
